// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZymD","tabsBox":"styles_tabsBox__3oTsx","createButton":"styles_createButton__lbWWH"};